var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.5348 12.3811C96.9638 8.17396 103.036 8.17396 105.465 12.3811L178.615 139.08C181.044 143.287 178.008 148.546 173.15 148.546H26.8503C21.9923 148.546 18.9561 143.287 21.3851 139.08L94.5348 12.3811Z",
    fill: "#14170E",
    stroke: "#10C237",
    strokeWidth: 2.91262
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2007_1047",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 7,
    width: 162,
    height: 144
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5348 12.3811C96.9638 8.17396 103.036 8.17396 105.465 12.3811L178.615 139.08C181.044 143.287 178.008 148.546 173.15 148.546H26.8503C21.9923 148.546 18.9561 143.287 21.3851 139.08L94.5348 12.3811Z",
    fill: "#14170E",
    stroke: "#10C237",
    strokeWidth: 2.91262
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2007_1047)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2007_1047)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 93.2038,
    cy: 211.439,
    rx: 106.796,
    ry: 85.4369,
    fill: "#10C237"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2007_1047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.209 98.1828C119.221 100.117 118.789 101.694 117.912 102.915C117.365 103.748 116.432 104.858 115.114 106.248C113.796 107.582 112.724 108.473 111.898 108.92C110.136 109.925 108.426 110.433 106.769 110.443L103.122 110.466L103.165 117.594L98.3581 117.623L98.3145 110.495L93.5901 110.524C89.9985 110.546 86.4757 108.274 83.0218 103.709C82.7428 103.269 82.2402 102.415 81.5141 101.149L89.7029 98.3634C90.8174 99.9038 92.0409 101.167 93.3731 102.154C93.4839 102.208 93.6775 102.235 93.9538 102.233L98.2637 102.207L98.2654 88.9448L87.8877 86.1902C85.8399 85.6502 84.2305 84.5272 83.0597 82.8214C81.9441 81.1153 81.38 79.2399 81.3675 77.1955L81.3386 72.4711C81.3271 70.5924 81.7318 69.0151 82.5529 67.7391C83.1007 66.9622 84.0336 65.9066 85.3516 64.5723C86.7246 63.1824 87.8239 62.2363 88.6497 61.734C90.4118 60.7285 92.1217 60.2207 93.7794 60.2106L98.1722 60.1837L98.1387 54.7134L102.946 54.6839L102.979 60.1543L106.046 60.1355C109.583 60.1138 113.105 62.3855 116.615 66.9504C117.172 67.7206 117.73 68.6842 118.29 69.8412L109.933 72.296C108.651 70.4804 107.428 69.2169 106.263 68.5057C106.208 68.4508 106.042 68.4242 105.765 68.4259L102.947 68.4431L103.027 81.4559L112.657 83.9664C114.65 84.5068 116.232 85.6575 117.403 87.4186C118.574 89.1244 119.165 90.9719 119.177 92.9611L119.209 98.1828ZM90.0682 76.8107C90.0733 77.6395 90.3801 78.1073 90.9886 78.2141L98.2116 80.1592L98.1401 68.4726L94.2445 68.4964L93.7478 68.5823C93.0867 68.9179 92.2894 69.5583 91.3558 70.5034C90.4775 71.4481 90.0393 72.0863 90.0413 72.4178L90.0682 76.8107ZM109.473 91.8601L103.08 90.1586L103.071 102.177L106.303 102.157L106.8 102.072C107.406 101.736 108.176 101.096 109.109 100.151C110.043 99.2059 110.509 98.5676 110.507 98.2361L110.476 93.2631C110.471 92.4342 110.137 91.9666 109.473 91.8601Z",
    fill: "url(#paint0_linear_2007_1047)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2007_1047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.4444 125.019C79.6747 126.417 79.5425 127.609 79.0478 128.593C78.7468 129.259 78.199 130.17 77.4044 131.327C76.6032 132.444 75.9291 133.211 75.3823 133.63C74.2219 134.56 73.0422 135.123 71.8434 135.321L69.2058 135.755L70.0544 140.91L66.5776 141.482L65.729 136.327L62.3121 136.89C59.7145 137.317 56.9038 136.076 53.8801 133.167C53.6276 132.881 53.166 132.32 52.4952 131.487L58.1041 128.532C59.0875 129.519 60.118 130.293 61.1956 130.855C61.2821 130.882 61.4252 130.879 61.6251 130.846L64.7422 130.333L63.2233 120.732L55.3946 119.927C53.8502 119.771 52.5564 119.142 51.5133 118.042C50.5101 116.934 49.8868 115.641 49.6433 114.163L49.0809 110.746C48.8572 109.387 48.9694 108.199 49.4176 107.181C49.7251 106.556 50.2795 105.685 51.0807 104.568C51.9153 103.404 52.6028 102.593 53.143 102.135C54.3034 101.205 55.4831 100.641 56.682 100.444L59.859 99.9208L59.2077 95.9645L62.6845 95.3921L63.3358 99.3485L65.5538 98.9834C68.1114 98.5624 70.9221 99.8031 73.9858 102.706C74.4776 103.199 74.9923 103.833 75.5301 104.606L69.7618 107.341C68.6256 106.174 67.5951 105.399 66.6703 105.018C66.6238 104.985 66.5006 104.984 66.3008 105.017L64.2627 105.353L65.8119 114.764L73.0715 115.478C74.5759 115.641 75.853 116.292 76.9028 117.433C77.9459 118.534 78.5859 119.803 78.8228 121.242L79.4444 125.019ZM55.8981 112.887C55.9968 113.486 56.2725 113.79 56.7252 113.797L62.1773 114.377L60.7859 105.925L57.9685 106.389L57.6187 106.508C57.1786 106.827 56.6748 107.382 56.1072 108.173C55.5797 108.958 55.3356 109.47 55.3751 109.71L55.8981 112.887ZM71.6711 121.557L66.8481 121.058L68.219 129.76L70.5568 129.375L70.9066 129.256C71.3068 128.944 71.7906 128.392 72.3581 127.601C72.9257 126.81 73.1897 126.295 73.1502 126.055L72.5582 122.458C72.4595 121.859 72.1638 121.558 71.6711 121.557Z",
    fill: "url(#paint1_linear_2007_1047)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_2007_1047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.181 129.67C148.873 131.054 148.306 132.11 147.479 132.839C146.952 133.344 146.104 133.986 144.935 134.763C143.775 135.5 142.864 135.961 142.2 136.146C140.777 136.576 139.472 136.659 138.286 136.395L135.677 135.814L134.542 140.914L131.102 140.148L132.237 135.049L128.857 134.296C126.288 133.724 124.142 131.525 122.422 127.698C122.294 127.338 122.075 126.646 121.763 125.622L128.07 124.972C128.614 126.255 129.281 127.358 130.072 128.28C130.142 128.338 130.276 128.388 130.474 128.432L133.557 129.118L135.728 119.644L128.764 115.978C127.39 115.257 126.424 114.191 125.866 112.781C125.348 111.379 125.252 109.947 125.578 108.484L126.33 105.104C126.629 103.76 127.176 102.699 127.972 101.922C128.49 101.457 129.329 100.855 130.489 100.117C131.698 99.349 132.638 98.8529 133.31 98.629C134.734 98.199 136.038 98.116 137.224 98.3799L140.367 99.0794L141.238 95.1656L144.678 95.9311L143.807 99.8449L146.001 100.333C148.531 100.896 150.676 103.096 152.437 106.931C152.709 107.573 152.95 108.353 153.161 109.271L146.789 109.658C146.17 108.151 145.502 107.048 144.786 106.349C144.756 106.301 144.642 106.255 144.444 106.211L142.428 105.762L140.356 115.072L146.825 118.441C148.16 119.153 149.102 120.234 149.651 121.684C150.209 123.095 150.329 124.511 150.012 125.935L149.181 129.67ZM131.857 109.633C131.725 110.226 131.868 110.61 132.285 110.786L137.127 113.358L138.988 104.996L136.201 104.376L135.832 104.356C135.305 104.488 134.63 104.815 133.809 105.337C133.027 105.869 132.609 106.253 132.556 106.49L131.857 109.633ZM143.259 123.56L138.97 121.299L136.997 129.884L139.309 130.399L139.678 130.419C140.166 130.278 140.821 129.947 141.642 129.424C142.464 128.902 142.901 128.522 142.954 128.285L143.746 124.727C143.878 124.134 143.716 123.745 143.259 123.56Z",
    fill: "url(#paint2_linear_2007_1047)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2007_1047",
    x: -82.6214,
    y: 56.9728,
    width: 351.651,
    height: 308.932,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 34.5146,
    result: "effect1_foregroundBlur_2007_1047"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2007_1047",
    x: 57.9605,
    y: 34.1399,
    width: 84.6268,
    height: 109.695,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.83368
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.6889
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.44 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2007_1047"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2007_1047",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2007_1047",
    x: 31.8342,
    y: 80.3345,
    width: 64.8551,
    height: 80.36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.07698
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.56753
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.44 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2007_1047"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2007_1047",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_2007_1047",
    x: 104.628,
    y: 80.1079,
    width: 65.6676,
    height: 80.0182,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.07698
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.56753
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.44 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2007_1047"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2007_1047",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2007_1047",
    x1: 100.086,
    y1: 54.7015,
    x2: 100.472,
    y2: 117.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73D689"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2007_1047",
    x1: 60.6165,
    y1: 95.7326,
    x2: 68.1062,
    y2: 141.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73D689"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2007_1047",
    x1: 142.632,
    y1: 95.4758,
    x2: 132.615,
    y2: 140.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73D689"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollars);
export default __webpack_public_path__ + "static/media/Dollars.e49442e81618660a1045e62aa637f3f7.svg";
export { ForwardRef as ReactComponent };